export const PACKAGE_PREFIX = 'universal-create';
export const TRIGGER_BUTTON_SPOTLIGHT_TARGET = `${PACKAGE_PREFIX}-trigger-button-target`;
export const TRIGGER_BUTTON_TEST_ID = `${PACKAGE_PREFIX}-trigger-button`;
export const ANALYTICS_CHANNEL = 'navigation';
export const MAX_ALLOWED_SECTIONS = 3;
export const SOURCE_LOCATION = 'universal-create';
export const ATI_PRESETS = {
	LOOM: 'ati:cloud:loom:video',
	GOAL: 'ati:cloud:townsquare:goal',
	TEAM: 'ati:cloud:townsquare:team',
	PROJECT: 'ati:cloud:townsquare:project',
};

/**
 * @private
 * @deprecated Use ATI_PRESETS.LOOM instead.
 */
export const LOOM_ATI = ATI_PRESETS.LOOM;

export const REQUIRED_USER_ITEMS = ['ati:cloud:townsquare:team', 'ati:cloud:townsquare:goal'];
